import { useAuthStore } from '../store/auth-store'

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    requiresMFA,
    login,
    verifyMFA,
    logout,
    loadUser,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
  } = useAuthStore()

  return {
    user,
    isAuthenticated,
    isLoading,
    requiresMFA,
    login,
    verifyMFA,
    logout,
    loadUser,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    hasRole,
    isSuperAdmin: user?.role === 'SUPER_ADMIN',
    isFinanceAdmin: user?.role === 'FINANCE_ADMIN',
    isSupportAdmin: user?.role === 'SUPPORT_ADMIN',
    isReadOnlyAuditor: user?.role === 'READ_ONLY_AUDITOR',
  }
}
